import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import {
  EntranceTicketType,
  QueryGetEntranceTicketTypeArgs,
} from 'apollo/generated/types';
import getApiLanguage from 'i18n/apiLanguage';

const GET_ENTRANCE_TICKET_TYPE = gql`
  query getEntranceTicketType($id: ID!, $date: String!, $language: Language) {
    getEntranceTicketType(id: $id, date: $date, language: $language) {
      name
      adultValue
      id
      maxStock
      otherValue
      remaining
      status
      description
      isBicycle
    }
  }
`;

const useGetEntranceTicketTypeQuery = (id: string, date: string, skip?: boolean) => {
  const { i18n } = useTranslation();

  const query = useQuery<
    { getEntranceTicketType: EntranceTicketType },
    QueryGetEntranceTicketTypeArgs
  >(GET_ENTRANCE_TICKET_TYPE, {
    variables: { id, date, language: getApiLanguage(i18n.language) },
    skip,
  });
  return query.data?.getEntranceTicketType;
};
export default useGetEntranceTicketTypeQuery;
